export const FETCH_SUCCESS = "LANGUAGES/FETCH_SUCCESS";
export const FETCH_ALL_SUCCESS = "LANGUAGES/FETCH_ALL_SUCCESS";
export const TABLE_UPDATE = "LANGUAGES/TABLE_UPDATE";

const types = {
    DESTROY_FAILED: "LANGUAGES/DESTROY_FAILED",
    DESTROY_REQUEST: "LANGUAGES/DESTROY_REQUEST",
    DESTROY_SUCCESS: "LANGUAGES/DESTROY_SUCCESS",

    FETCH_FAILED: "LANGUAGES/FETCH_FAILED",
    FETCH_REQUEST: "LANGUAGES/FETCH_REQUEST",
    FETCH_SUCCESS,

    FETCH_ALL_FAILED: "LANGUAGES/FETCH_ALL_FAILED",
    FETCH_ALL_REQUEST: "LANGUAGES/FETCH_ALL_REQUEST",
    FETCH_ALL_SUCCESS,

    FETCH_DEFAULT_FAILED: "LANGUAGES/FETCH_DEFAULT_FAILED",
    FETCH_DEFAULT_REQUEST: "LANGUAGES/FETCH_DEFAULT_REQUEST",
    FETCH_DEFAULT_SUCCESS: "LANGUAGES/FETCH_DEFAULT_SUCCESS",

    GET_FAILED: "LANGUAGES/GET_FAILED",
    GET_REQUEST: "LANGUAGES/GET_REQUEST",
    GET_SUCCESS: "LANGUAGES/GET_SUCCESS",

    PATCH_FAILED: "LANGUAGES/PATCH_FAILED",
    PATCH_REQUEST: "LANGUAGES/PATCH_REQUEST",
    PATCH_SUCCESS: "LANGUAGES/PATCH_SUCCESS",

    STORE_FAILED: "LANGUAGES/STORE_FAILED",
    STORE_REQUEST: "LANGUAGES/STORE_REQUEST",
    STORE_SUCCESS: "LANGUAGES/STORE_SUCCESS",

    UPDATE_FAILED: "LANGUAGES/UPDATE_FAILED",
    UPDATE_REQUEST: "LANGUAGES/UPDATE_REQUEST",
    UPDATE_SUCCESS: "LANGUAGES/UPDATE_SUCCESS",

    TABLE_UPDATE,
};

export default types;
